module.exports = __webpack_public_path__ + "vue_assets/img/badge_deios_helping_fairy.3f923dee.png";